<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="投票号/参赛姓名/会员ID" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="status" slot="prepend" placeholder="筛选条件" @change='getList()'>
                      <el-option label="待审核"   value="1"></el-option>
                      <el-option label="审核通过" value="2"></el-option>
                      <el-option label="拒绝" value="3"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="报名时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="userid"
        label="会员ID"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        label="参赛姓名"
        >
      </el-table-column>
      <el-table-column
        prop="votenum"
        label="投票号"
        >
      </el-table-column>
      <el-table-column
        label="审核状态">
      <template slot-scope="scope"> 
        <el-tag type="primary" v-if="scope.row.status==1">待审核</el-tag><el-tag type="success" v-else-if="scope.row.status==2">审核通过</el-tag><el-tag type="danger" v-else-if="scope.row.status==3">审核拒绝({{scope.row.msg}})</el-tag>
      </template>
      </el-table-column>
      <el-table-column
        label="票数"
        >
        <template slot-scope="scope">
           <div>{{scope.row.total}}</div>
           <div><el-button type="info" plain @click="addPiaoshu(scope.row.votenum)" size="small">增加票数<i class="el-icon-caret-top el-icon--right"></i></el-button></div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
      <template slot-scope="scope"> 
        <el-button type="primary" v-if="scope.row.status==1||scope.row.status==3" @click="openDiag(scope.row)">审核</el-button>
        <el-button v-else @click="openDiag(scope.row)">查看</el-button>
      </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>

      <el-dialog
        title="投票图片审核"
        :visible.sync="dialogVisible"
        width="50%"
        >
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>参赛姓名：{{diagItem.name}}</span>
          </div>
          <div class="imgrow">
              <div class="imgcol">
                 <div class="imgbtn">
                  <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh-left" size="mini" plain @click="rotateImg(1,1)">逆时针转90度</el-button>
                    <el-button type="primary" size="mini" plain @click="rotateImg(2,1)">顺时针转90度<i class="el-icon-refresh-right"></i></el-button>
                  </el-button-group>
                 </div>
                 <div class="imgcon">
                   <img :src="diagItem.img1" class="imgself" />
                 </div>
              </div>
              <div class="imgcol">
                <div class="imgbtn">
                  <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh-left" size="mini" plain @click="rotateImg(1,2)">逆时针转90度</el-button>
                    <el-button type="primary" size="mini" plain @click="rotateImg(2,2)">顺时针转90度<i class="el-icon-refresh-right"></i></el-button>
                  </el-button-group>
                 </div>
                <div class="imgcon">
                 <img :src="diagItem.img2" class="imgself" />
                </div> 
              </div>
          </div>
        </el-card>
        <span slot="footer" class="dialog-footer" v-if="diagItem.status==1||diagItem.status==3">
          <el-button type="success" @click="doCheck(2)">审核通过</el-button>
          <el-button type="danger"  @click="doCheck(3)">残忍拒绝</el-button>
        </span>
      </el-dialog>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        status:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },
        dialogVisible:false,
        diagType:0,
        diagItem:{},
        processing:false
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/Wevote/getVoteList",{pageinfo:this.pageinfo,keywords:this.keywords,status:this.status}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.list
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      openDiag(itemInfo){
         this.dialogVisible=true
         this.diagItem=itemInfo
      },
      doCheck(status){
        if(this.processing){
          this.$message.error("请等待审核完成");return false;
        }
        let msg=''
        if(status==2){
           msg='您确定该会员资料已完整，审核通过吗？' 
        }else if(status==3){
           msg='您确定要拒绝通过吗？(用户可重新修改后再提交)'
        }
        this.$confirm(msg, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           if(status==3){
                 this.$prompt('请输入拒绝原因', '必填', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                  }).then(({ value }) => {
                    if(value==''||value==undefined){
                      this.$message.error("请输入拒绝原因，以便用户知晓并修改");return false;
                    }
                    this.processing=true
                    this.$post("/Wevote/doCheck",{userid:this.diagItem.userid,status:status,msg:value}).then((data)=>{
                      this.processing=false
                      if(data.result.success){
                          this.$message.success(data.result.info)
                          setTimeout(()=>{this.getList();this.dialogVisible=false},1000)
                      }else{
                          this.$message.error(data.result.info)
                      }
                    })
                  })
           }else{
             this.processing=true
             this.$post("/Wevote/doCheck",{userid:this.diagItem.userid,status:status,msg:''}).then((data)=>{
               this.processing=false
               if(data.result.success){   
                  this.$message.success(data.result.info)
                  setTimeout(()=>{this.getList();this.dialogVisible=false},1000)
               }else{
                  this.$message.error(data.result.info)
               }
             })
           }
        })
      },
      rotateImg(rotateType,imgIndex){
        this.$confirm('您确定要调整该用户上传的图片吗？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$post("/Wevote/rotateImg",{voteid:this.diagItem.id,index:imgIndex,type:rotateType}).then((data)=>{
              if(data.result.success){
                this.diagItem['img'+imgIndex]=data.result.info
                this.$message.success("操作成功")
              }else{
                this.$message.error(data.result.info)
              } 
            })
        })
      },
      addPiaoshu(votenum){
        this.$post("/Wevote/addPiaoshu",{votenum:votenum}).then((data)=>{
              if(data.result.success){
                this.$message.success(data.result.info)
                this.getList();
              }else{
                this.$message.error(data.result.info)
              } 
            })
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.imgrow{width:100%;display: flex;flex-flow: row nowrap;}
.imgcol{width:50%;display: flex;flex-flow: column nowrap;}
.imgcon{width:100%;height: 400px;}
.imgself{width:100%;height:100%;}
</style>
